enum Usos {
    Interno = 1,
    Externo = 2
}

export default Usos;